import { useQuery } from '@tanstack/react-query'

import { downloadPaymentRequestsCsv } from '@src/api'
import { DefaultApiDownloadPaymentRequestsCsvRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useDownloadPaymentRequestsCsv = ({
  organizationId,
  ...params
}: DefaultApiDownloadPaymentRequestsCsvRequest) => {
  const { axiosInstance } = useAxios()
  const { data, isError, isLoading, refetch } = useQuery({
    // CSV download is only fired when a button is clicked, so enabled is set to false.
    enabled: false,
    queryFn: () =>
      downloadPaymentRequestsCsv(axiosInstance, { organizationId, ...params }),
    queryKey: [REACT_QUERY_CACHE_KEYS.DOWNLOAD_PAYMENT_REQUESTS_CSV],
  })

  return { data, isError, isLoading, refetch }
}
